// const axios = require('axios');


export default () => {

    const form = document.querySelector('[data-subscribe]');
    const success = document.querySelector('.footer__subscribe-message');
    if (form) {
        
        
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const data = new FormData(form);
            const xhr = new XMLHttpRequest();
            xhr.open('POST', form.getAttribute('action'));
            xhr.onload = () => {
                if (xhr.status === 200) {
                    form.reset();

                    success.classList.add('active');
                        window.setTimeout(() => {
                            success.classList.remove('active');
                        }, 6000);

                }
            }
            xhr.send(data);
            return false;
            
        })
    }

}

// export default () => {

//     const form = document.querySelector('[data-subscribe]');
//     const success = document.querySelector('.footer__subscribe-message');
//     if (form) {
//         form.addEventListener('submit', (e) => {
//             e.preventDefault();
//             axios.post(form.getAttribute('action'), {
//                 email: form.querySelector('[name="email"]').value
//             }).then(() => {
//                 form.querySelector('input[type="email"]').value = '';

//                 success.classList.add('active');
//                 window.setTimeout(() => {
//                     success.classList.remove('active');
//                 }, 6000);


//                 // Thanks for signing up to the Cloke mailing list! We'll try not to spam you - and you can unsubscribe at any time.
//             });
//             return false;
//         })
//     }

// }
